<div *ngIf="model?.additional?.messageHistory && model?.additional?.messageHistory?.length > 0">
  <h4 *ngIf="model.heading" class="gsm-nachricht-referent_heading">
    {{ model.heading }}
    <button mat-icon-button matTooltip="Im NV Cockpit öffnen" (click)="goToInfoclient()">
      <mat-icon *ngIf="model.icon" class="info-icon" data-test="gsm-nachricht-referent_icon">{{ model.icon }}</mat-icon>
    </button>
  </h4>
</div>
